import { useState, useEffect, useRef } from "react";
import "./ScrollToTopButton.scss";
import IconGoToTopArrow from "app/pages/.shared/static/icons/IconGoToTopArrow";
import useIntersectionObserver from "app/pages/.shared/useIntersectionObserver";
import classNames from "classnames";

const ScrollToTopButton = () => {
	const [isVisible, setIsVisible] = useState(false);
	const targetRef = useRef(null);

	const isIntersecting = useIntersectionObserver(targetRef.current, false, {
		rootMargin: "0px",
		threshold: 0.1,
	});

	useEffect(() => {
		if (isIntersecting === "LEAVING_FROM_TOP") {
			setIsVisible(true);
		} else {
			setIsVisible(false);
		}
	}, [isIntersecting]);

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	const buttonClass = classNames("icon scroll-to-top-btn", {
		"scroll-to-top-btn--visible": isVisible,
	});

	return (
		<>
			{/* Élément cible pour l'observation */}
			<div ref={targetRef} style={{ position: "absolute", top: "400px" }} />
			<a type="button" className={buttonClass} onClick={scrollToTop}>
				<IconGoToTopArrow width={50} height={50} />
			</a>
		</>
	);
};

export default ScrollToTopButton;
